<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 200px">
      <div class="left-top">
        <div class="flex-1 font-16-30313a">报表分类</div>
      </div>
      <div class="flex-1 h-0" v-if="menuList && menuList.length">
        <cate-menu :not-operate="true" :menu-data="menuList" @on-choose="onChooseMenu" :choose-id="chooseMenuId"></cate-menu>
      </div>
    </div>
    <div class="flex-1 h-100 flex-column ptb-10 pr-20 pl-10">
      <div class="flex content-top mb-10">
        <div class="flex-1 bg-ff h-100 flex align-center pl-5 mr-10">
          <div class="tab-item active">
            <span class="bg-4-46b8b0"></span>
            {{currentClassify.name}}
          </div>
        </div>
        <div class="btn-30-bg-82b925-big flex align-center" style="min-width: 65px;" @click="onAddReport">
          <div class="mr-5">
            <i class="el-icon-circle-plus" style="color: #fff; font-size: 14px"></i>
          </div>
          新增报表
        </div>
        <el-upload
          v-show="false"
          ref="uploadDom"
          name="file"
          :httpRequest="uploadFile"
          :action="upload"
          :show-file-list="false">
          <el-button size="small" id="uploadBtn" type="primary">选取文件</el-button>
        </el-upload>
      </div>
      <div class="hr"></div>
      <div class="flex-1">
        <vxe-table
          border
          ref="erpTable"
          height="100%"
          auto-resize
          resizable
          highlight-hover-row
          show-overflow
          show-header-overflow
          size="mini"
          :data="reportList"
          @edit-closed="editClosedEvent"
          :edit-config="{trigger: 'dblclick', mode: 'row'}">
          <vxe-table-column field="operate" title="操作" width="160" v-slot="{ row }">
            <div class="flex align-center">
              <div class="btn-16-color-46b8b0 btn-hover-46b8b0 mr-5" @click="onUpload({row})">导入</div>
              <div class="btn-16-color-46b8b0 btn-hover-46b8b0 mr-5" @click="onDownload(row)">导出</div>
              <div class="btn-16-color-46b8b0 btn-hover-46b8b0" @click="onDelete(row)">删除</div>
            </div>
          </vxe-table-column>
          <vxe-table-column field="name" title="名字" width="220" :edit-render="{name: 'input'}"></vxe-table-column>
          <vxe-table-column v-if="currentClassify.type == 2 || currentClassify.type == 3 || currentClassify.type == 7" field="orderType" title="单据类型" width="220" :edit-render="{}">
            <template v-slot:edit="{ row }">
              <select v-model="row.orderType" class="vxe-default-select">
                <option v-for="item in list" :key="item.id" :value="item.name">{{ item.name }}</option>
              </select>
            </template>
          </vxe-table-column>
          <!--<vxe-table-column v-if="currentClassify.type == 3" field="orderType" title="单据类型2" width="220" :edit-render="{}">-->
            <!--<template v-slot:edit="{ row }">-->
              <!--<select v-model="row.orderDefineId" class="vxe-default-select">-->
                <!--<option v-for="item in orderDefineList" :key="item.id" :value="item.name">{{ item.name }}</option>-->
              <!--</select>-->
            <!--</template>-->
          <!--</vxe-table-column>-->
          <vxe-table-column field="grf" title="模板" width="800"></vxe-table-column>
        </vxe-table>
        <!--<erp-table ref="erpTable" :table-data="reportList" :loading="loading" is-edit="true" @on-upload="onUpload" @on-download="onDownload"-->
                   <!--:column-data="columnData" @on-modify="onModifyInRow" modify-method="on-modify" @on-delete="onDelete"></erp-table>-->
      </div>
    </div>
  </div>
</template>

<script>
import CateMenu from '../../components/CateMenu'
import ErpTable from '../../components/ErpTable'
import XEUtils from 'xe-utils'
XEUtils.mixin({
  toType (cellValue) {
    return cellValue === 1 ? '允许领料' : cellValue === -1 ? '不允许领料' : ''
  }
})
export default {
  name: 'reportDefine',
  components: {CateMenu, ErpTable},
  data () {
    return {
      chooseMenuId: 1,
      menuList: [],
      reportList: [],
      currentClassify: {},
      currentReport: {},
      loading: true,
      upload: `${this.$store.state.API_URL_9009}/fileUpload/uploadFile`,
      columnData: [
        {
          field: 'operate', // 若为操作，则固定为operate
          title: '操作',
          width: '220',
          isDefine: true,
          child: [{
            type: 'btn',
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
            title: '导入',
            methodName: 'on-upload'
          }, {
            type: 'btn',
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
            title: '导出',
            methodName: 'on-download'
          }, {
            type: 'btn',
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
            title: '删除',
            methodName: 'on-delete'
          }]
        }, {
          field: 'name',
          title: '名字',
          width: '200',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'orderType',
          title: '单据类型',
          width: '200',
          editType: 'select',
          editRender: {
            name: 'select'
          },
          options: [
          ],
          formatter: 'toType'
        }, {
          field: 'grf',
          title: '模板',
          minWidth: '200'
        }
      ],
      orderDefineList: [],
      payType: [
        {
          id: 1,
          name: '收款'
        },
        {
          id: 2,
          name: '付款'
        },
        {
          id: 3,
          name: '提成'
        }
      ],
      list: []
    }
  },
  created () {
    this.getReportClassify()
    this.getOrderList()
  },
  mounted () {},
  methods: {
    getOrderList () {
      let params = {
        companyId: this.$store.state.companyId
      }
      this.axios.post('orderDefine/list', params).then(res => {
        if (res.data.success) {
          this.orderDefineList = res.data.data
        }
      })
    },
    editClosedEvent ({ row, column }, event) {
      this.onModifyInRow(row, column, column.property)
    },
    onDelete (row) {
      let that = this
      this.$confirm(`删除“${row.name}”模板之后不可恢复哦，是否继续？`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        that.axios.post('report/deleteById', that.qs.stringify({id: row.id})).then(res => {
          if (res.data.success) {
            that.$message.success('删除成功')
            that.getReport()
          } else {
            that.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }).catch(() => {
        that.$message.info('已取消操作！')
      })
    },
    onDownload (row) {
      if (row.grf) {
        window.open(row.grf)
      } else {
        this.$message.warning('该报表还没有上传模板！')
      }
    },
    onUpload ({row}) {
      this.currentReport = row
      this.$refs.uploadDom.$refs['upload-inner'].handleClick()
    },
    uploadFile (e) {
      let formData = new FormData()
      formData.append('fileData', e.file)
      formData.append('type', 2)
      formData.append('description', '')
      this.axios.post(`${this.$store.state.API_URL_9009}/fileUpload/uploadFile`, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        this.currentReport.grf = onloadRes.data.data.path
        this.onModifyInRow(this.currentReport, null, 'grf')
      }).catch(() => {
        this.$message.error('上传失败！')
      })
    },
    onModifyInRow (row, column, colName) {
      let params = {
        id: row.id,
        name: row.name
      }
      if (colName === 'grf') {
        params.grf = row.grf
      }
      for (let i = 0; i < this.list.length; i++) {
        if (row.orderType === this.list[i].name) {
          params.orderDefineId = this.list[i].id
        }
      }
      this.axios.post('report/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功！')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onAddReport () {
      let params = {
        companyId: this.$store.state.companyId,
        classifyId: this.chooseMenuId
      }
      this.axios.post('report/save', params).then(res => {
        if (res.data.success) {
          this.$refs.erpTable.insertAt(res.data.data, this.reportList[0], 'name')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getReport () {
      this.loading = true
      this.axios.post('report/list', {companyId: this.$store.state.companyId, classifyId: this.chooseMenuId}).then(res => {
        this.loading = false
        if (res.data.success) {
          if (this.currentClassify.type === 3) {
            this.list = this.payType
          } else {
            this.list = this.orderDefineList
          }
          for (let j = 0; j < res.data.data.length; j++) {
            for (let i = 0; i < this.list.length; i++) {
              if (res.data.data[j].orderDefineId === this.list[i].id) {
                res.data.data[j].orderType = this.list[i].name
              }
            }
            // if (res.data.data[j].orderDefineId) {
            //
            // } else {
            //   res.data.data[j].orderType = ''
            //   res.data.data[j].orderDefineId = ''
            // }
          }
          this.reportList = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getReportClassify () {
      this.axios.post('reportClassify/list', {companyId: this.$store.state.companyId}).then(res => {
        if (res.data.success) {
          this.menuList = res.data.data
          this.currentClassify = this.menuList[0]
          this.chooseMenuId = this.menuList[0].id
          this.getReport()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onChooseMenu (menu) {
      if (menu.id !== this.chooseMenuId) {
        this.chooseMenuId = menu.id
        this.currentClassify = menu
        this.getReport()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    cursor: pointer;
  }
  .content-top {
    height: 30px;
    .tab-item {
      font-size: 16px;
      color: #272727;
      display: flex;
      align-items: center;
      margin-right: 15px;
      cursor: pointer;
      span {
        height: 16px;
      }
      &.active {
        color: #46b8b0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/reportDefine.vue